import {useSyncExternalStore} from 'react';
import {sizes} from '../utils/variables';

export const VIEWPORT = {
    phone: sizes.mobile,
    tablet: sizes.tablet,
    transactionsLayout: 1200,
} as const;

const subscribe = (onStoreChange: () => void) => {
    window.addEventListener('resize', onStoreChange);
    return () => window.removeEventListener('resize', onStoreChange);
};

export const useMediaQuery = (maxWidth: number) => useSyncExternalStore(
    subscribe,
    () => window.innerWidth <= maxWidth,
    () => false,
);

export const useIsPhone = () => useMediaQuery(VIEWPORT.phone);
export const useIsTransactionsMobileLayout = () => useMediaQuery(VIEWPORT.transactionsLayout);
export const useIsCompactLayout = () => useMediaQuery(VIEWPORT.tablet);
export const useIsBelowDesktop = () => useMediaQuery(sizes.desktop - 1);
